<template>
  <v-dialog
    :value="open"
    :persistent="true"
    max-width="400"
    overlay-opacity="0.35"
    @input="onClose"
  >
    <v-card
      class="pa-5"
      rounded="lg"
      elevation="8"
      style="min-width: 365px;"
    >
      <div
        class="d-flex justify-end"
        style="width: 100%;"
      >
        <v-btn
          icon
          x-small
          class="synthesis-brand-dark-blue--text"
          @click="onClose"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card-title
        class="d-flex flex-column pa-0 align-start"
        style="gap:8px;"
      >
        <synthesis-icon :name="success ? 'success' : 'refresh'" />
        <span
          :class="'font-weight-medium ' + (success ? 'mb-6' : '')"
          style="letter-spacing: 0.2px;line-height: 130%;font-size:14px;"
        >
          {{ success ? successTitle : title }}
        </span>
      </v-card-title>

      <v-card-text class="pa-0">
        <div>
          <p
            v-if="!success"
            class="font-weight-medium synthesis-ui-grey-01--text mb-4"
            style="line-height: 130%;letter-spacing: 0.2px;font-size:14px;"
          >
            {{ subtitle }}
          </p>

          <v-progress-linear
            :value="progress"
            color="synthesis-ui-blue-04"
            height="6"
            rounded
          />
        </div>
        <div
          v-if="success"
          class="d-flex flex-column mt-7"
        >
          <p class="pa-0 ma-0">
            {{ successSubtitle }}
          </p>
          <p
            class="pa-0 ma-0 font-weight-medium synthesis-ui-blue-04--text synthesis-ui-green-01--text"
            style="letter-spacing: 0.2px;text-decoration: underline;cursor: pointer;"
            @click="onSuccessLinkClick"
          >
            {{ successLinkText }}
          </p>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SynthesisIcon from '@/theme/default/components/common/icons/SynthesisIcon.vue'

export default {
  name      : 'RerunModal',
  components: {
    SynthesisIcon
  },
  props: {
    open: {
      type   : Boolean,
      default: false
    },
    onClose: {
      type    : Function,
      required: true
    },
    title: {
      type    : String,
      required: true
    },
    subtitle: {
      type    : String,
      required: true
    },
    progress: {
      type   : Number,
      default: 0
    },
    success: {
      type   : Boolean,
      default: false
    },
    successTitle: {
      type   : String,
      default: ''
    },
    successSubtitle: {
      type   : String,
      default: ''
    },
    successLinkText: {
      type   : String,
      default: ''
    },
    onSuccessLinkClick: {
      type   : Function,
      default: () => {}
    }
  }
}
</script>
